import React from "react";
import CartItems from "../components/cart/CartItems";

export default function Cart() {
  return <CartItems />;
}
